import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { createSelector } from "reselect";

const slice = createSlice({
  name: "pvp",
  initialState: {
    pvpList: [],
    totalCount: null,
    pvpInfo: null,
    loading: false,
    pvpGameList: [],
    pvpGameTotalCount: null,
  },
  reducers: {
    pvpRequested: (pvp, action) => {
      pvp.loading = true;
    },
    pvpReceived: (pvp, action) => {
      pvp.pvpList = action.payload.data;
      pvp.totalCount = action.payload.totalCount;
      pvp.loading = false;
    },
    pvpRequestFailed: (pvp, action) => {
      pvp.loading = false;
    },

    pvpInfoRequested: (pvp, action) => {
      pvp.loading = true;
    },
    pvpInfoReceived: (pvp, action) => {
      pvp.pvpInfo = action.payload.data;
      pvp.loading = false;
    },
    pvpInfoRequestFailed: (pvp, action) => {
      pvp.loading = false;
    },

    deletePvpReceived: (pvp, action) => {
      const id = action.payload;
      pvp.pvpList = pvp.pvpList.filter((item) => item._id !== id);
      pvp.totalCount = pvp.totalCount - 1;
    },
    updatePvpReceived: (state, action) => {
      const ind = state.pvpList.findIndex((challenge) => challenge._id === action.payload._id);
      const newChallenges = state.pvpList;
      newChallenges[ind] = { ...newChallenges[ind], ...action.payload };
      state.pvpList = [...newChallenges];
    },
    pvpGamesRequested: (pvp, action) => {
      pvp.loading = true;
    },
    pvpGamesReceived: (pvp, action) => {
      pvp.pvpGameList = action.payload.data;
      pvp.pvpGameTotalCount = action.payload.totalCount;
      pvp.loading = false;
    },
    pvpGamesRequestFailed: (pvp, action) => {
      pvp.loading = false;
    },
  },
});

export const {
  pvpRequested,
  pvpReceived,
  pvpRequestFailed,
  pvpInfoRequested,
  pvpInfoReceived,
  pvpInfoRequestFailed,
  deletePvpReceived,
  updatePvpReceived,
  pvpGamesReceived,
  pvpGamesRequested,
  pvpGamesRequestFailed,
} = slice.actions;

export default slice.reducer;

// API base URL
const pvpUrl = "pvp-contest/";

// ----------------------------------------
// Load ALL PvP Contests
// ----------------------------------------
export const loadPvPContests = (params, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: pvpUrl,
      params,
      onStart: pvpRequested.type,
      onSuccess: pvpReceived.type,
      onError: pvpRequestFailed.type,
      callback,
    }),
  );
};
export const loadPvPGames = (params, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: "pvp-games",
      params,
      onStart: pvpGamesRequested.type,
      onSuccess: pvpGamesReceived.type,
      onError: pvpGamesRequestFailed.type,
      callback,
    }),
  );
};

// ----------------------------------------
// Load PvP Contest Details
// ----------------------------------------
export const loadPvPContestDetails = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: pvpUrl + id,
      onStart: pvpInfoRequested.type,
      onSuccess: pvpInfoReceived.type,
      onError: pvpInfoRequestFailed.type,
      callback,
    }),
  );
};

// ----------------------------------------
// Create PvP Contest
// ----------------------------------------
export const addPvPContest = (data, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: pvpUrl,
      method: "POST",
      data,
      callback,
    }),
  );
};

// ----------------------------------------
// Update PvP Contest
// ----------------------------------------
export const updatePvPContest = (id, data, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: pvpUrl + id,
      method: "PUT",
      data,
      callback,
    }),
  );
};

// ----------------------------------------
// Delete PvP Contest
// ----------------------------------------
export const deletePvPContest = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: pvpUrl + id,
      method: "DELETE",
      onSuccess: deletePvpReceived.type,
      callback,
    }),
  );
};

export const getPvP = createSelector(
  (state) => state.entities.pvp,
  (pvp) => pvp,
);
